import React from "react";
import ReactSelect, {components} from "react-select";

import {useLocalization} from "../../../../customHooks/useContextLocalization";

import {ReactComponent as IconDropdown} from "./images/icon-dropdown.svg";


const ClearIndicator = () => "";
const DropdownIndicator = () => <IconDropdown
    className="product-from-icon-search"
    width="0.75rem"
    height="0.5rem"
/>;
const Option = ({children, ...props}) => {
    return <span className={props.isSelected ? "modal-sharing-selected-option" : "modal-sharing-option"}><components.Option {...props}>{children}</components.Option></span>;
};


export default function ({setSharingMode, sharingMode}) {
    const locale = useLocalization();

    const changeValue = option => setSharingMode(option?.value || "");

    const options = [
        {label: locale.get.studio.sharing.noRights, value: "nothing"},
        {label: locale.get.studio.sharing.viewing, value: "viewer"},
        {label: locale.get.studio.sharing.commenting, value: "commentator"},
        {label: locale.get.studio.sharing.editing, value: "editor"},
    ];

    const getCurrentOption = (mode) => {
        console.log(mode);
        let option = options[0];
        for (let i = 0; i < options.length; i++) {
            if (options[i].value === mode) {
                option = options[i];
                break;
            }
        }
        return option;
    }

    return <ReactSelect
        isPlanar
        isSearchable={false}
        className="sharing-single-select"
        options={options}
        components={{ClearIndicator, DropdownIndicator, Option}}
        value={getCurrentOption(sharingMode)}
        onChange={changeValue}
    />;
}
